export default "__VITE_ASSET__XCJxR4kl__"